/**
 * @file src/core/quality.js
 * Phân tier thiết bị. v1 CỐ TÌNH đơn giản: chỉ dò và trả tier, chưa đổi LOD.
 * Trigger để làm đầy đủ: xem KE-HOACH-DU-AN-MAU.md mục C.4.1.
 */

/** @typedef {'low' | 'mid' | 'high'} QualityTier */

/**
 * @param {import('three').WebGLRenderer} renderer
 * @returns {{ tier: QualityTier, pixelRatioMax: number, info: Record<string, unknown> }}
 */
export function detectQuality(renderer) {
  const gl = renderer.getContext();
  const dbg = gl.getExtension('WEBGL_debug_renderer_info');
  const gpu = dbg ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL)) : 'unknown';

  const forced = new URLSearchParams(location.search).get('tier');
  const cores = navigator.hardwareConcurrency ?? 4;
  const mem = /** @type {any} */ (navigator).deviceMemory ?? 4;

  const integrated = /Intel|UHD|HD Graphics|Iris|Apple GPU|Mali|Adreno|PowerVR/i.test(gpu);

  /** @type {QualityTier} */
  let tier = 'mid';
  if (forced === 'low' || forced === 'mid' || forced === 'high') {
    tier = forced;
  } else if (cores <= 4 && integrated) {
    tier = 'low';
  } else if (cores >= 8 && !integrated) {
    tier = 'high';
  }

  // Chính sách "chất lượng cao nhất, không cắt giảm": KHÔNG hạ độ phân giải render nữa.
  // Bộ số cũ (low 1 · mid 1.5 · high 2) cắt bớt pixel để cứu GPU tích hợp — nay bỏ trần
  // cho máy khoẻ (Infinity ⇒ boot.js lấy đúng devicePixelRatio của màn, kể cả 3x) và nới
  // hai tier còn lại.
  // low VẪN GIỮ MỘT TRẦN (1.5, không phải Infinity): trên máy 4 nhân + GPU tích hợp thì
  // render 3x là tụt xuống vài fps — lúc đó không còn là "chất lượng cao" mà là bài
  // không dùng được. Đây là trần AN TOÀN, không phải cắt giảm chất lượng asset.
  const pixelRatioMax = tier === 'low' ? 1.5 : tier === 'mid' ? 2 : Infinity;

  return {
    tier,
    pixelRatioMax,
    info: {
      gpu,
      cores,
      deviceMemory: mem,
      integrated,
      forced: forced ?? null,
      maxTextureSize: gl.getParameter(gl.MAX_TEXTURE_SIZE),
      etc1s: !!gl.getExtension('WEBGL_compressed_texture_etc'),
      astc: !!gl.getExtension('WEBGL_compressed_texture_astc'),
      s3tc: !!gl.getExtension('WEBGL_compressed_texture_s3tc'),
    },
  };
}
